// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__UgzmE","calendarButtons":"ClockData_calendarButtons__1TH45"};